/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AccountId/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import InfoPopover from './InfoPopover/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AccountId({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders/Accounts/Content/ProviderAccount/AccountId"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let providerAccountAccountIdValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'account_id',
})
let providerAccountProviderValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'provider',
})
let constantData = 'payabli'
let aggregateData = fromAggregate.equals(providerAccountProviderValueData, constantData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="AccountId.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-cLwbO': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="provider_account.account_id"
 text={providerAccountAccountIdValueData}
/>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<Popover
{...childProps}
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnRightClick={false}
 showOnHover={true}
 placement="bottom-right"
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<fromFlow.When is={aggregateData}>
<div
  data-testid="AccountId.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconInfoFilled
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 fill={dtColorsNeutral500}
 width={dtSpaceS}
 height={dtSpaceS}
/>
</div>
</fromFlow.When>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
 width={480}
>
{childProps => (
<InfoPopover
{...childProps}
  viewPath={`${viewPath}/InfoPopover`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
)}
</SupportOnly>
</div>
{children}
</React.Fragment>)
}